export const phone = 480;
export const tablet = 768;
export const laptop = 1024;
export const desktop = 1366;
export const full = 1920;

const breakpoints = {
  values: {
    xs: phone,
    sm: tablet,
    md: laptop,
    lg: desktop,
    xl: full,
  },
};

export default breakpoints;
